// class that provide 'libComm' initialization.
// put something like the following in your app.modules.ts

// ...
// providers: [
// 		any service that is 'injected' goes here
//
// 		CoreService,
// 		LibCommService,
// 		{provide: 'ITranslatorManager', useClass : MockupTranslatorInit},
// 		{provide: 'IAuthorizeService', useClass: MockupAuthorizeService},
// 		{provide: 'IIdentityService', useClass: MockupIdentityService},
// 		{provide: 'IAppInfoService', useClass: MockupAppInfoService},
//  	...
//  	...
// ],
// ...

import {Inject, Injectable} from '@angular/core';

import {CoreService} from "libComm/services/Core.service";
import {IAuthorizeService} from "libComm/interfaces/IAuthorizeService";
import {IAppInfoService} from "libComm/interfaces/IAppInfoService";
import {IIdentityService} from "libComm/interfaces/IIdentityService";
import {ITranslatorManager} from "libComm/interfaces/ITranslatorManager";

import {IMenuService} from "libComm/interfaces/IMenuService";


@Injectable({
	providedIn: 'root'
})
export class LibCommService
{
	// injection of Interfaces that need to be implemented by the main application
	constructor(private cs: CoreService,
				@Inject('IAuthorizeService') private authS : IAuthorizeService,
				@Inject('IAppInfoService') private infoS : IAppInfoService,
				@Inject('IIdentityService') private identS : IIdentityService,
				@Inject('ITranslatorManager') private trm : ITranslatorManager,
				@Inject('IMenuService') private menus: IMenuService)
	{
		// init all services used by the CoreService
		cs.setAuthService(authS);
		cs.setAppInfo(infoS);
		cs.setIdentityService(identS);
		cs.setTranslatorManager(trm);
		cs.setMenuService(menus);

		// set application title
		// this.title= ms.getAppInfo().getAppName();
	}


	// return CoreService
	getCoreService(): CoreService
	{
		return this.cs;
	}

	// main library initializer that has to be called by the application :
	// trm (optional) translator initializer
	//
	libInit(): void
	{
		// if ( this.trm != null )
		// {
			// use custom initialization for translator
			// this.cs.applyCustomTranslatorInit(this.trm);
		// }
		// else
		// {
			// call default initialization for translator
			// this.cs.initTranslatorDefault();
		// }

		// use custom initialization for translator
		this.cs.applyCustomTranslatorInit();
	}
}